"use client";

import type { GenericActionTone } from "./actionBar.types";

const ACTION_TONE_COLOR_MAP: Partial<Record<GenericActionTone, string>> = {
  primary: "moveon.primary",
  success: "moveon.success",
  warning: "moveon.warning",
  error: "moveon.danger",
};

const ACTION_TONE_HOVER_BG_MAP: Partial<Record<GenericActionTone, string>> = {
  primary: "moveon.primaryLight",
  success: "moveon.successLight",
  warning: "moveon.warningLight",
  error: "moveon.dangerLight",
};

const ACTION_TONE_BG_MAP: Partial<Record<GenericActionTone, string>> = {
  primary: "moveon.primaryLight",
  success: "moveon.successLight",
  warning: "moveon.warningLight",
  error: "moveon.dangerLight",
};

export function getActionToneColor(
  tone?: GenericActionTone,
): string | undefined {
  if (!tone || tone === "default") {
    return undefined;
  }

  return ACTION_TONE_COLOR_MAP[tone];
}

export function getActionToneHoverBg(
  tone?: GenericActionTone,
): string | undefined {
  if (!tone || tone === "default") {
    return undefined;
  }

  return ACTION_TONE_HOVER_BG_MAP[tone];
}

export function getActionToneBg(
  tone?: GenericActionTone,
): string | undefined {
  if (!tone || tone === "default") {
    return undefined;
  }

  return ACTION_TONE_BG_MAP[tone];
}
